module.exports = __webpack_public_path__ + "img/players.40448f50.svg";